import './App.css';
import Header from './components/Header';
import Home from './components/Home';
import "./components/style.css"
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <>
      <Header />
      <Home />
    </>
  );
}

export default App;